import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFire,
  faChartLine,
  faTrophy,
  faMedal,
  faPlane
} from '@fortawesome/free-solid-svg-icons';
import BattlePass from './BattlePass';
import CareerProgress from './CareerProgress';
import Achievements from './Achievements';
import RankShowcase from './RankShowcase';
import './Career.css';

const Career = () => {
  const [activeTab, setActiveTab] = useState('challenges');
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    // Check for any new achievements or milestones
    checkForNotifications();
  }, []);

  const checkForNotifications = () => {
    // This would normally check with the backend for new unlocks
    const stored = localStorage.getItem('careerNotifications');
    if (stored) {
      setNotifications(JSON.parse(stored));
      localStorage.removeItem('careerNotifications');
    }
  };

  const tabs = [
    {
      id: 'challenges',
      name: 'Desafíos Mensuales',
      icon: faFire,
      color: 'fire'
    },
    {
      id: 'progress',
      name: 'Mi Progreso',
      icon: faChartLine,
      color: 'progress'
    },
    {
      id: 'achievements',
      name: 'Logros',
      icon: faTrophy,
      color: 'achievements'
    },
    {
      id: 'ranks',
      name: 'Rangos',
      icon: faMedal,
      color: 'ranks'
    }
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'challenges':
        return <BattlePass />;
      case 'progress':
        return <CareerProgress />;
      case 'achievements':
        return <Achievements />;
      case 'ranks':
        return <RankShowcase />;
      default:
        return <BattlePass />;
    }
  };

  return (
    <div className="career-container">
      {/* Barra de navegación horizontal estilo moderno */}
      <div className="career-nav-bar">
        <div className="nav-brand">
          <FontAwesomeIcon icon={faPlane} className="brand-icon" />
          <h1>Carrera</h1>
        </div>
        <nav className="nav-menu">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`nav-item ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <FontAwesomeIcon icon={tab.icon} />
              <span>{tab.name}</span>
            </button>
          ))}
        </nav>
      </div>

      {notifications.length > 0 && (
        <div className="notifications-banner">
          {notifications.map((notification, index) => (
            <div key={index} className="notification-item">
              <FontAwesomeIcon icon={faMedal} />
              <span>{notification.message}</span>
            </div>
          ))}
        </div>
      )}

      <div className="career-content">
        {renderContent()}
      </div>
    </div>
  );
};

export default Career;